import { iws_isInSearchState } from "../basic";
import { IsiIconType, IsiMessageMode, IsiShortcut } from "../Isilog.enums";
import { IsiXmlDataResult } from "./XmlDataResult";
import { XmlLog } from "./XmlLog";
import { IsiPlMergeModel } from "../Isilog/PresentationLogic/IsiPlMergeModel";
import { IIsiDtoPlMergeModelMergeResult, IIsiDtoPlMergeModelRequest } from "../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMergeModel";
import { IIsiUIFlowResultGeneric } from "../Isilog/Core/IIsiUIFlowResultGeneric";


declare const CTRL_TREEVIEW: number;
declare const CTRL_ISIBUTTON: number;
declare const CTRL_ISIHYPERLINK: number;
declare const CTRL_IMAGE: number;
declare const CTRL_LABEL: number;

export class XmlUserSettingsResult {

    private _log: XmlLog;
    // Constantes donnant le type de clause xml, filtre ou valeur par defaut.
    // DGRA - 03/05/2011 - DEV41536 : Gestion du tooltip
    public static readonly XML_DEFAULT_VALUE = "DF";
    public static readonly XML_DEFAULT_VALUE_BTN = "XMLDEFAULTVALUEBTN";
    public static readonly XML_FILTER = "FL";
    public static readonly XML_FILTER_EXECUTE = "FLE";
    public static readonly XML_DESIGN = "DE";
    public static readonly XML_TOOLTIP = "XMLTOOLTIP";
    private static readonly EVALUATION_OK = "EVALOK";
    private static readonly NO_EVALUATION = "NOEVAL";
    private static readonly ISI_XML_ERROR_TAG = "ISIXMLERROR";
    // Constante contenant le separateur de couple controle/valeur
    private static readonly SEP_COUPLE = "#S#";
    private _uniqueId: string = "none";

    public constructor(uniqueId: string) {
        this._uniqueId = uniqueId;
        this._log = new XmlLog('XmlUserSettingsResult');
        this._log.setId(this._uniqueId);
    }

    /**
     * Application du résultat d'une évaluation 
     * @param {any} xmlResult
     */
    public evaluateXmlResult(xmlResult, ctrlsDesignEvaluated) {
        // ok lbri
        let r = this._extractDataXmlResult(xmlResult);

        this._log.log("evaluateXmlResult : " + r.type + " " + r.result + " ctrl=" + r.ctrl.id + ", value=" + r.val + ", text=" + r.txt + ", extendedMode=" + r.extendedMode);

        if (r.result === XmlUserSettingsResult.EVALUATION_OK) {
            switch (r.type) {
                case XmlUserSettingsResult.XML_DEFAULT_VALUE_BTN:
                    this._executeDfResultForBtn(r.ctrl, r.val);
                    break;
                case XmlUserSettingsResult.XML_DEFAULT_VALUE:
                    if (r.hasTxt) {
                        this._executeDfCnxResult(r.ctrl, r.val, r.txt);
                    } else {
                        this._executeDfResult(r.ctrl, r.val, r.extendedMode);
                    }
                    break;

                case XmlUserSettingsResult.XML_DESIGN:
                    this._executeDeResult(r.ctrl, r.val);

                    ctrlsDesignEvaluated[r.ctrl.id] = r.ctrl;              
                    break;

                case XmlUserSettingsResult.XML_FILTER_EXECUTE:
                    this._executeFiResult(r.ctrl, r.val);
                    break;

                case XmlUserSettingsResult.XML_TOOLTIP:
                    this._executeTtResult(r.ctrl, r.val);
                    break;

                default:
                    return;
            }

        } else if (r.result === XmlUserSettingsResult.ISI_XML_ERROR_TAG) {
            uiCore.showMessage('MsgXmlAnalyserError', { mode: IsiMessageMode.SessionMode, height: 400, width: 500, iconType: IsiIconType.UserError });
        }

    }

    /**
        * Extraction des données 
        * @param {any} xmlResult
        */
    private _extractDataXmlResult(xmlResult): IsiXmlDataResult {

        let values = xmlResult.Val.split(XmlUserSettingsResult.SEP_COUPLE);
        let ret = new IsiXmlDataResult(values[1], values[0], iwsAllCtrls.getCtrl(xmlResult.Ctrl), xmlResult.Type);

        if (typeof (xmlResult.ExtendedMode) !== "undefined" && xmlResult.ExtendedMode !== null) {
            ret.extendedMode = xmlResult.ExtendedMode;
        }

        if (typeof (xmlResult.Txt) !== "undefined" && xmlResult.Txt !== null) {
            ret.txt = xmlResult.Txt;
            ret.hasTxt = true;
        }

        return ret;

    }

    /*-- CREATION ----------------------------------------------------------------------------
    '- Auteur      : ABON
    '- Date        : 2009/07/21
    '- Description : [TACHE: 26145]  -  Execute la bonne action suivant le resultat de la val def du controle
    '-- PARAMETRES ---------------------------------------------------------------------------
    ' ENTREE
    '   -> evaluatedCtrl : le controle en cours d'evaluation
    '   -> result : le resultat de l'evaluation a interpreter
    '-----------------------------------------------------------------------------------------*/
    /**
     * 
     * @param {any} ctrl
     * @param {any} value
     */
    private _executeDfResult(ctrl: IwsControle, value: string, extendedMode: boolean): void {

        if (uiCore.getIsModeDiag()) {
            this._log.log("_executeDfResult " + ctrl.id + " de '" + ctrl.valueWithContext({ isValdef: true }) + "' vers '" + value + "'");
        }
        if (extendedMode) {
            ctrl.setExtendedMode(extendedMode);
        }
        const newValue: string = this._mergeIntoSingleBody(value)

        ctrl.setValue(newValue);

    }

    /**
    * Fusionne tout le contenu d'un HTML dans un seul <body>.
    * @param html Chaîne HTML potentiellement mal formée.
    * @returns Chaîne HTML corrigée avec un seul body contenant tout le texte.
    */
    private _mergeIntoSingleBody(html: string): string {

        // On cherche le contenu du body avec une regex :
        // - <body[^>]*>    → la balise ouvrante <body> (avec ou sans attributs)
        // - ([\s\S]*?)     → capture tout le contenu entre <body> et </body>
        // - </body>        → la balise fermante
        // - i              → insensible à la casse
        //
        // => bodyMatch[0] = <body>...contenu...</body>
        // => bodyMatch[1] = uniquement le contenu interne du body
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i)

        if (!bodyMatch) return html

        const bodyContent = bodyMatch[1];

        // On récupère ce qui traîne après </html> ou </body>
        // - split(/<\/html>/i)[1] → donne ce qu’il y a après </html>
        // - si absent, split(/<\/body>/i)[1] → ce qu’il y a après </body>
        // - sinon, chaîne vide
        const afterMatch = html.split(/<\/html>/i)[1] || html.split(/<\/body>/i)[1] || "";

        const newBody = bodyContent + "\n" + afterMatch.trim();

        // On remplace l’ancien bloc <body>...</body> par un nouveau
        // - Regex : /<body[^>]*>[\s\S]*?<\/body>/i → sélectionne tout le body original
        // - Remplacement : un body propre qui contient le contenu initial + le texte recollé
        return html.replace(/<body[^>]*>[\s\S]*?<\/body>/i, `<body>\n${newBody}\n</body>`);
    }

    /**
     * 
     * @param {any} ctrl
     * @param {any} value
     * @param {any} text
     */
    private _executeDfCnxResult(ctrl: IwsControle, value: string, text: string) {

        if (text == "PropertyNotAllowed") return;

        if (uiCore.getIsModeDiag()) {
            this._log.log("_executeDfCnxResult " + ctrl.id + " de '" + ctrl.valueWithContext({ isValdef: true }) + "'/'" + ctrl.getText() + "' vers '" + value + "'/'" + text + "'");
        }

        // On execute la modification de valeur du connexe, puis on mis à jour les libellés pour éviter plusieurs requête ajax.
        ctrl.setAlreadyLoadedText(true);
        ctrl.setValue(value);
        ctrl.setAlreadyLoadedText(false);
        IsiAsyncCtrlConnexeHandleResult(text);
        //On rappelle la méthode rafraichissant le libellé pour les controles alignés à droite
        iws_IsiSuggestUpdateShownValue(ctrl.fullId, true);
    }

    private _executeDfResultForBtn(ctrl: IwsControle, result: string): void {

        /// <summary>
        ///
        /// </summary>
        /// <param name="trigger" type="Object">le controle à l'origine du déclenchement de cette évaluation</param>
        /// <param name="ctrl" type="Object">le controle dont on veut evaluer la valeur par defaut</param>
        /// <history>
        /// <entry mat="LBRI" date="13/11/2015" task="DEV113176">Création</entry>
        /// <entry mat="LBRI" date="20/11/2015" task="DEV113522">Modification</entry>
        /// <entry mat="YLAR" date="20/01/2016" task="DEV110459">Modification Ajout du retour des taches planifiées</entry>
        /// </history>

        if (result == "") { return; }

        this._log.log("_executeDfResultForBtn " + ctrl.id + " '" + result + "'");

        try {

            const processresult = this._jsonTryParse(result);
            if (processresult && processresult.Type == "merge") {

                // reposte la page
                var tabActions = [];
                tabActions.push(processresult.Action);
                iws_LaunchShortCutAction(processresult.ActionType, tabActions, null, null, processresult.Name);

                return;
            } else if (processresult && processresult.Type == "report" && processresult.Url != "") {
                setTimeout(function () { window.open(processresult.Url, "", "scrollbars=1,resizable=yes,toolbar=yes,directories=yes,menubar=yes"); }, 0);
            } else if (processresult && processresult.Type == "task" && processresult.Msg != "") {
                // YLAR dans le cas d'une tache planifiée on affiche uniquement le message de retour de la tache.
                //GBAU - 14/03/2016 : La fonction dans laquelle on est est appeler uniquement si l'évaluation est ok
                if (processresult.ProcessInError) {
                    uiCore.showErrorMessage(processresult.Msg);
                } else {
                    uiCore.showMessage(processresult.Msg);
                }
            } else if (processresult && processresult.Type == "mergeauto" && processresult.CursorPage == CURSOR_STATE_CONSULT) {

                this.mergeauto(processresult);

            }
        } catch (ex) {
                uiCore.logError("Error in ExecuteDfResultForBtn", ex);
            
        }
    }


     private async mergeauto(processresult){
        /**
        * Lance la fusion
        * */

         const dataRestricted: boolean = true;
         const screenDesignName: string = document.getElementById("FormHeader").getAttribute("data-screencode")
         const pl = new IsiPlMergeModel();

         //On utilisera pas la séquence dans un mergeauto puisque la balise process ne laisse pas la possibilité de configurer la séquence.
         const dto: IIsiDtoPlMergeModelRequest = {
             modelName: processresult.Name,
             mergeOnlyCurrentRecord: processresult.MergeOnlyCurrentRecord,
             attachment: processresult.Attachment,
             displayResults: processresult.ToDownload,
             dataRestricted: dataRestricted,
             prefixeSequence: '',
             suffixeSequence: '',
             screenType: processresult.ScreenType,
             screenDesignName: screenDesignName,
             associatedViewContextId: '',
             codeModel: processresult.CodeModel,
             modelType: processresult.TypeDoc,
             useSequence: false, 
             startSequence: '',
             endSequence: '',
             errorCode: processresult.ErrorCode
         };

        //code réutilisé venant du publipostage dans la GLOB026.js en mode merge (avec popin)
         uiCore.setModifWaitStatus(true, true, TREATING);

         await pl.merge(dto)
            .then(() => {
                if (dto.attachment === true && dto.errorCode !== -1) {
                    // Refresh des PJ (en faisant un refresh d'écran → vu avec GREN)
                    uiCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_REFRESH);
                }
            }).catch((errorMsg) => {
                uiCore.showErrorMessage(errorMsg);
            }).finally(() => {
                uiCore.setModifWaitStatus(false, false, null);
            });
    }


    /*-- CREATION ----------------------------------------------------------------------------
    '- Auteur      : DGRA
    '- Date        : 03/05/2011
    '- Description : DEV41536 : gestion des tooltips dynamiques
    '-- PARAMETRES ---------------------------------------------------------------------------
    ' ENTREE
    '   -> ctrl : le controle en cours d'evaluation
    '   -> result : le resultat de l'evaluation a interpreter
    '   MAXB - 28/04/2020 - Attention si le tooltip ne retourne pas de données result vaut "-"
    '-----------------------------------------------------------------------------------------*/
    private _executeTtResult(ctrl: IwsControle, result: string): void {

        this._log.log("_executeTtResult " + ctrl.id + " '" + result + "'");

        // YLAR 17/07/2015 DEV10743: Nouvelle ergo des tooltip dynamique
        // MAXB On parse le contenu JSON
        //MTAB 1/12/2023 : dysf 0000103852 qui affiche un infobulle null 
        let objResultat;
        if (result !== "" && result !== "-") {
            // YLAR 11/01/2018 : Correction de la sérialisation /déserialisation des données retournées par la vue de la tooltip
            objResultat = this._jsonTryParse(result);

            this._log.log(' ---> IsiToolTip ' + ctrl.id + " " + result);

            ctrl.setTooltipTitle(objResultat.ISITITLE);
            ctrl.setTooltipImage(objResultat.ISIIMAGE);
            ctrl.setTooltip(objResultat.TOOLTIP);
        } else {
            ctrl.setTooltip("-");
        }
    }

    /*-- CREATION ----------------------------------------------------------------------------
    '- Auteur      : ABON
    '- Date        : 2009/07/21
    '- Description : [TACHE: 26145]  -  Execute la bonne action suivant le resultat du filtre du controle
    '-- PARAMETRES ---------------------------------------------------------------------------
    ' ENTREE
    '   -> evaluatedCtrl : le controle en cours d'evaluation
    '   -> result : le resultat de l'evaluation a interpreter
    '-----------------------------------------------------------------------------------------*/
    private _executeFiResult(ctrl: IwsControle, result: string): void {

        // si la valeur n'appartient pas au nouveau filtre alors on vide le champ
        if (result === "") {

            this._log.log('_executeFiResult ' + ctrl.id + " de '" + ctrl.valueWithContext({ isValdef: true }) + "' vers ''");

            ctrl.setValue("");
        }
        // Dans le cas ou on évalue le filtre d'un controle
        ctrl.onEvaluateFilter();
    }

    /*-- CREATION ----------------------------------------------------------------------------
    '- Auteur      : ABON
    '- Date        : 2009/07/21
    '- Description : [TACHE: 26145]  -  Execute la bonne action suivant le resultat du design def du controle
    /*-- MODFICATION ----------------------------------------------------------------------------
    '- Auteur      : HGLE
    '- Date        : 2011/08/16
    '- Description : [TACHE: 42364]  -  En cas d'imbrication dans un panel, on regarde d'abord la valeur de celui-ci
    '-- PARAMETRES ---------------------------------------------------------------------------
    ' ENTREE
    '   -> evaluatedCtrl : le controle en cours d'evaluation
    '   -> result : le resultat de l'evaluation a interpreter
    '-----------------------------------------------------------------------------------------*/
    private _executeDeResult(ctrl: IwsControle, result: string): void {

        const res = Sys.Serialization.JavaScriptSerializer.deserialize(result);
        const isSearch = iws_isInSearchState();

        for (let sProp in res) {
            switch (sProp) {
                case "IsiUpdateMode":
                    if (isSearch) { continue; }
                    if (ctrl.ctrlType != CTRL_LABEL) {

                        const propagModif = iws_parentPropagationValue(iws_parent(ctrl), "PANEL_MODIF");
                        if (!propagModif) {

                            this._log.log('_executeDeResult ---> IsiUpdateMode ' + ctrl.id + " " + res.IsiUpdateMode);

                            if (res.IsiUpdateMode.toUpperCase() == "J") {

                                iwsAllCtrls.iwsAddReadOnlyCtrl(ctrl.id);
                            } else {
                                iwsAllCtrls.iwsRemoveReadOnlyCtrl(ctrl.id);
                            }
                        } else {

                            this._log.log('_executeDeResult ---> IsiUpdateMode ' + ctrl.id + " " + propagModif);

                            if (propagModif == "J") {
                                iwsAllCtrls.iwsAddReadOnlyCtrl(ctrl.id);
                            } else {
                                iwsAllCtrls.iwsRemoveReadOnlyCtrl(ctrl.id);
                            }
                        }
                    }

                    break;
                case "IsiVisible":

                    // cas ou le controle decide de sa visibilite
                    const propagVisible = iws_parentPropagationValue(iws_parent(ctrl), "PANEL_VISIBLE");
                    // Si la valeur Visible du controle en base est false alors on ne fait rien
                    // en effet le render n'aura alors rendu qu'un controle cache => impossible de le rendre visible
                    // sinon on change la valeur en utilisant la valeur renvoyee par l'evaluation du XML
                    if (ctrl.bSysVisible) {
                        if (!propagVisible) {

                            this._log.log('_executeDeResult ---> IsiVisible ' + ctrl.id + " " + res.IsiVisible);

                            if (res.IsiVisible == 'false') {
                                ctrl.bXmlVisible = false;
                            } else {
                                ctrl.bXmlVisible = true;
                            }
                        }
                        else {

                            if (propagVisible == "O") {

                                this._log.log('_executeDeResult ---> IsiVisible ' + ctrl.id + " true");

                                ctrl.bXmlVisible = true;
                            } else {

                                this._log.log('_executeDeResult ---> IsiVisible ' + ctrl.id + " false");

                                ctrl.bXmlVisible = false;
                            }
                        }
                        ctrl.visible(ctrl.bXmlVisible);
                    }
                    break;
                case "IsiCompulsory":
                    if (isSearch) { continue; }
                    if (ctrl.ctrlType != CTRL_TREEVIEW && ctrl.ctrlType != CTRL_ISIBUTTON && ctrl.ctrlType != CTRL_ISIHYPERLINK
                        && ctrl.ctrlType != CTRL_IMAGE && ctrl.ctrlType != CTRL_LABEL) {

                        const propagOblig = iws_parentPropagationValue(iws_parent(ctrl), "PANEL_OBLIG");
                        if (!propagOblig) {

                            this._log.log('_executeDeResult ---> IsiCompulsory ' + ctrl.id + " " + res.IsiCompulsory);

                            if (eval(res.IsiCompulsory.toLowerCase())) {
                                iwsAllCtrls.iwsAddCompulsoryCtrl(ctrl.id);
                            } else {
                                iwsAllCtrls.iwsRemoveCompulsoryCtrl(ctrl.id);
                            }
                        } else {

                            this._log.log('_executeDeResult ---> IsiCompulsory ' + ctrl.id + " " + propagOblig);

                            if (propagOblig == "O") {
                                iwsAllCtrls.iwsAddCompulsoryCtrl(ctrl.id);
                            } else {
                                iwsAllCtrls.iwsRemoveCompulsoryCtrl(ctrl.id);
                            }
                        }
                    }
                    break;
            }

        }

    }

    /**
     * Safe Json parse
     * @param {any} value
     */
    private _jsonTryParse(value: string): any {

        let res;
        try {
            res = JSON.parse(value);
        } catch (ex) {
            res = value;
        }
        return res;
    }

}
